import { doNothing } from "./doNothing";
import { handleFrontendError } from "./handleFrontendError";

/**
 * When you want to run a promise, but don't care about its resulting resolution
 * or rejection, use this. It gracefully handles errors and does nothing when the
 * promise resolves.
 *
 * This is useful for deferred promises, typically in the browser.
 *
 * Note: AVOID USING THIS IN NODE. Await your node.js promises fully, to help
 * with ensuring that we get good, clean stack traces, that we clean up open handles
 * properly and on time, and that we avoid the potential for memory leaks. You
 * _can_ do this in node, but it's more likely to cause problems. So avoid it.
 */
export function handleBackgroundPromise(promise?: Promise<unknown>): void {
  promise?.then(doNothing).catch(handleFrontendError);
}
